import React from "react";
import CheckboxLabel from "../labels/CheckboxLabel";

const CheckboxInput = (props) => {
  const {
    id,
    name,
    value,
    checked,
    label,
    readOnly,
    disabled,
    onChange,
    className,
    classLabel,
    size,
    position,
    labelStyle={}
  } = props;

  const checkboxSize = size ? size : "lg:h-6 lg:w-6 h-[22px] w-[22px]";
  const checkboxStyle = `cursor-pointer accent-blue-500 border-gray-500 round-[2px] focus:ring-blue-600 focus:ring-1 rounded-[2px] disabled:bg-[#C5C5C6] disabled:cursor-not-allowed ${checkboxSize} ${className}`;

  return (
    <div className={`flex items-center ${position}`}>
      <input
        type="checkbox"
        name={name}
        id={id ? id : null}
        value={value ? value : ''}
        checked={checked?? false}
        onChange={onChange}
        className={checkboxStyle}
        readOnly={readOnly !== undefined ? readOnly : null}
        disabled={disabled !== undefined ? disabled : null}
      />
      {label && (
        <CheckboxLabel text={label} className={classLabel} htmlFor={id} checked={checked} style={labelStyle}/>
      )}
    </div>
  );
};

export default CheckboxInput;
